/* eslint-disable no-debugger */
import { Component, OnInit } from '@angular/core';

import { OAuthService } from 'angular-oauth2-oidc';
import { lastValueFrom } from 'rxjs';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';

import { authConfig } from 'apps/app1/src/models/sso.config';
import { GoogleApiService, UserInfo } from '../../services/google-api.service';


@Component({
  selector: 'nxt-test-auth2',
  templateUrl: './test-auth2.component.html',
  styleUrls: ['./test-auth2.component.scss'],
})
export class TestAuth2Component implements OnInit {

  mailSnippets: string[] = []
  userInfo?: UserInfo

  constructor(
    private oauthService: OAuthService,
    private googleApi: GoogleApiService

  ) {

     //https://www.youtube.com/watch?v=AcuzemsJfxA&ab_channel=ShaheerShukur
     //this.configureSingleSignOn();

    googleApi.userProfileSubject.subscribe(info => {


      this.userInfo = info
    })

  }

  ngOnInit(): void {}


  isLoggedIn(): boolean {
    return this.googleApi.isLoggedIn()
  }

  logout() {
    this.googleApi.signOut()
  }

  async getEmails() {


    if (!this.userInfo) {
      return;
    }

    const userId = this.userInfo?.info.sub as string

    const messages = await lastValueFrom(this.googleApi.emails(userId))

    messages.messages.forEach((element: any) => {

      const mail = lastValueFrom(this.googleApi.getMail(userId, element.id))

      mail.then(mail => {

        this.mailSnippets.push(mail.snippet)

      })

    });

  }

  configureSingleSignOn() {

    //https://www.youtube.com/watch?v=AcuzemsJfxA&ab_channel=ShaheerShukur
    this.oauthService.configure(authConfig);

    this.oauthService.tokenValidationHandler = new JwksValidationHandler();

    this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }


  //The Authorization Code Flow + PKCE is an OpenId Connect flow specifically designed to authenticate native or mobile application users.
  //This flow is considered best practice when using Single Page Apps (SPA) or Mobile Apps. PKCE, pronounced “pixy” is an acronym for Proof Key for Code
  //Exchange.
  // private CallAuthService() {

  //
  //   this.oidcSecurityService.checkAuth().subscribe(

  //     ({ isAuthenticated, userData }) => {
  //
  //     },
  //     (error: any) => {

  //
  //       console.log(error);

  //     }

  //   );
  // }

  //https://angular-auth-oidc-client.com/docs/intro
  //user
  //max
  //pass
  //geheim
  // login() {

  //
  //   //this.oidcSecurityService.authorize();

  //   //Ouath 2 pakcage
  //   this.oauthService.initImplicitFlow();

  //   //https://github.com/manfredsteyer/angular-oauth2-oidc/blob/master/docs-src/code-flow.bak.md
  //   //this.oauthService.initCodeFlow();


  // }


  // logout() {

  //
  //   //this.oidcSecurityService.logoff();

  //   //Ouath 2 pakcage
  //   this.oauthService.logOut();

  // }

  // hasToken() : boolean {

  //   let retVal = false;

  //   retVal = this.getTokenOrNull();

  //
  //   return retVal;

  // }

  // getTokenOrNull(){

  //
  //   let retVal = false;

  //   // let claims:any = this.oauthService.getIdentityClaims();

  //   // retVal = claims ? claims : null;

  //   return retVal;

  // }
}
